import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "business-danger-dialog__content" }
const _hoisted_2 = { class: "business-danger-dialog__summary" }
const _hoisted_3 = { class: "business-danger-dialog__keyword" }
const _hoisted_4 = { class: "business-danger-dialog__input-card" }
const _hoisted_5 = { class: "business-danger-dialog__input-top" }
const _hoisted_6 = { class: "business-danger-dialog__field-chip" }
const _hoisted_7 = { class: "business-danger-dialog__footer-actions" }

import { computed, nextTick, ref, watch } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'BusinessDangerDialog',
  props: {
    title: {},
    formatDangderDeleteInfo: { type: Function },
    onOk: { type: Function },
    onCancel: { type: Function },
    textOk: {},
    textCancel: {},
    hideOk: { type: Boolean },
    hideCancel: { type: Boolean },
    optName: {}
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

const open = ref(false);
const row = ref<any>(null);
const inputDate = ref('');
const okLoading = ref(false);
const cancelLoading = ref(false);
const inputId = `business-danger-dialog-input-${Math.random()
  .toString(36)
  .slice(2)}`;

const confirmKeyword = computed(() => props.optName || '删除');
const deleteInfo = computed(() => props.formatDangderDeleteInfo?.(row.value) || '');
const summaryLeadText = computed(() => {
  const info = deleteInfo.value.trim();
  if (info) {
    return `${info.replace(/[，。,；;！!？?]+$/u, '')}，请输入`;
  }
  return '此操作执行后数据不可恢复，请输入';
});
const inputPlaceholder = computed(() => `请输入“${confirmKeyword.value}”以继续`);
const canConfirm = computed(() => inputDate.value === confirmKeyword.value);

watch(open, async(value) => {
  if (!value || typeof document === 'undefined') {
    return;
  }
  await nextTick();
  document.getElementById(inputId)?.focus();
});

const handleOk = async() => {
  if (!canConfirm.value || okLoading.value) {
    return;
  }
  okLoading.value = true;
  try {
    await props.onOk?.(row.value);
    open.value = false;
  } finally {
    okLoading.value = false;
  }
};

const handleCancel = async() => {
  if (cancelLoading.value) {
    return;
  }
  cancelLoading.value = true;
  try {
    await props.onCancel?.();
    open.value = false;
  } finally {
    cancelLoading.value = false;
  }
};

__expose({
  showDialog: (_row: any) => {
    inputDate.value = '';
    row.value = {
      ...(_row || {}),
    };
    open.value = true;
  },
});

return (_ctx: any,_cache: any) => {
  const _component_HpsfirInput = _resolveComponent("HpsfirInput")!
  const _component_HpsfirButton = _resolveComponent("HpsfirButton")!
  const _component_HpsfirProDrawer = _resolveComponent("HpsfirProDrawer")!

  return (_openBlock(), _createBlock(_component_HpsfirProDrawer, {
    open: open.value,
    "onUpdate:open": _cache[2] || (_cache[2] = ($event: any) => ((open).value = $event)),
    title: __props.title || '',
    width: "420px",
    "max-width": "calc(100vw - 32px)",
    "mobile-height": "75vh",
    "mobile-max-height": "75vh"
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_7, [
        (!__props.hideCancel)
          ? (_openBlock(), _createBlock(_component_HpsfirButton, {
              key: 0,
              variant: "outline",
              loading: cancelLoading.value,
              onClick: handleCancel
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(__props.textCancel || '取消'), 1)
              ]),
              _: 1
            }, 8, ["loading"]))
          : _createCommentVNode("", true),
        (!__props.hideOk)
          ? (_openBlock(), _createBlock(_component_HpsfirButton, {
              key: 1,
              variant: "destructive",
              disabled: !canConfirm.value,
              loading: okLoading.value,
              onClick: handleOk
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(__props.textOk || '确认'), 1)
              ]),
              _: 1
            }, 8, ["disabled", "loading"]))
          : _createCommentVNode("", true)
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("p", _hoisted_2, [
          _createTextVNode(_toDisplayString(summaryLeadText.value) + " ", 1),
          _createElementVNode("span", _hoisted_3, "“" + _toDisplayString(confirmKeyword.value) + "”", 1),
          _cache[3] || (_cache[3] = _createTextVNode(" 后再点击确认。 ", -1))
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("label", {
              class: "business-danger-dialog__field-label",
              for: inputId
            }, "输入确认词"),
            _createElementVNode("span", _hoisted_6, _toDisplayString(confirmKeyword.value), 1)
          ]),
          _createVNode(_component_HpsfirInput, {
            id: inputId,
            modelValue: inputDate.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputDate).value = $event)),
            placeholder: inputPlaceholder.value,
            class: "business-danger-dialog__input",
            autocomplete: "off",
            onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (canConfirm.value && handleOk()), ["enter"]))
          }, null, 8, ["modelValue", "placeholder"]),
          _cache[4] || (_cache[4] = _createElementVNode("p", { class: "business-danger-dialog__hint" }, "仅在输入内容与关键字完全一致时才可继续。", -1))
        ])
      ])
    ]),
    _: 1
  }, 8, ["open", "title"]))
}
}

})